import { AxiosResponse } from "axios";
import { AutoCompleteDataModelDtoPaginatedList, UserSelectionEntityType, UserSuggestionsType } from "generated/CoreApi_v1";
import { coreApiV1 } from "providers/CoreApiProvider";

function getMembers(searchText: string): Promise<AxiosResponse<AutoCompleteDataModelDtoPaginatedList>> {
    const inputValue = searchText.trim().toLowerCase();
    return coreApiV1.suggestions.users({ pageNumber: 1, pageSize: 10, searchText: inputValue, type: UserSuggestionsType.Any, includeYourself: true, selectionHistoryType: UserSelectionEntityType.User });
}

function getTopics(searchText: string): Promise<AxiosResponse<AutoCompleteDataModelDtoPaginatedList>> {
    const inputValue = searchText.trim().toLowerCase();
    return coreApiV1.suggestions.topics({ pageNumber: 1, pageSize: 10, searchText: inputValue, ignoreSelectionHistory: false, isInterestAssigment: false, categories: null, applyKnowledgeTests: false });
}

export const publicationMentionConfig = {
    mention: {
        allowedChars: /^[A-Za-z\sÁÉÍÓÚáéíóúÀÈÌÒÙàèìòùÇçÃãÕõÂÊÎÔÛãêîôûÅÄÖåäö]*$/,
        mentionDenotationChars: ["@", "#"],
        dataAttributes: [
            "id",
            "value",
            "denotationChar",
            "link",
            "target",
            "disabled",
            "ot"
        ],
        positioningStrategy: "fixed",
        source: function (searchTerm: any, renderList: any, mentionChar: any) {
            if (mentionChar === "@") {
                getMembers(searchTerm)
                    .then((users) => {
                        var values = users.data.items.map((d) => ({ id: d.key, value: d.label, ot: "user" }));
                        renderList(values, searchTerm);
                    })
                    .catch(() => {
                        renderList([], searchTerm);
                    });
            }
            else if (mentionChar === "#") {
                getTopics(searchTerm)
                    .then((topics) => {
                        var values = topics.data.items.map((d) => ({ id: d.key, value: d.label, ot: "topic" }));
                        renderList(values, searchTerm);
                    })
                    .catch(() => {
                        renderList([], searchTerm);
                    });
            }
        }
    }
};
